import * as React from 'react';

export const SuccessfulIcon = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{'C1F6149D-4E7F-44F6-BDE2-F0AE4AE8C367@1x'}</title>
      <path
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm9.692-21.536a.5.5 0 010 .708L14.386 22.478a.506.506 0 01-.007.007l-.707.707a.5.5 0 01-.708 0l-.707-.707-.007-.008-4.942-4.941a.5.5 0 010-.708l.707-.707a.5.5 0 01.707 0l4.596 4.595 10.96-10.959a.5.5 0 01.707 0l.707.707z"
        fill="#317D4F"
        fillRule="evenodd"
      />
    </svg>
  );
};
